module.exports = __webpack_public_path__ + "img/Science.b7096ae5.svg";